import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {MANAGE_ENROLLEMENT, MANAGE_ENROLLEMENT_API_URL, GET_ALL_MANAGE_ENROLLEMENT_API_URL, GET_MANAGE_ENROLLEMENT_COURSES_API_URL, VERIFY_MANAGE_ENROLLEMENT_PAYMENT_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  ManageEnrollementErrors       : {},
  permission: permission?.manage_enrollement ?? [],
  ManageEnrollementShowMessage  : null,
  ManageEnrollementResult       : [],
  ManageEnrollementCourses       : [],
  ManageEnrollementButtonSpinner : false,
  ManageEnrollementTableLoading : true,
  ManageEnrollementAddDrawer    : false,
  ManageEnrollementEditData     : [],
  ManageEnrollementButtonAndModelLabel  : setLocale('manageenrollement.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewManageEnrollementData: [],
    ViewManageEnrollementLoader: true,
    DrawerStatus: 0,
};

export const createManageEnrollement = createAsyncThunk(
    "createManageEnrollement",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, MANAGE_ENROLLEMENT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getManageEnrollement = createAsyncThunk(
    "getManageEnrollement",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_MANAGE_ENROLLEMENT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewManageEnrollement = createAsyncThunk(
  "viewManageEnrollement",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, MANAGE_ENROLLEMENT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteManageEnrollement = createAsyncThunk(
  "deleteManageEnrollement",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, MANAGE_ENROLLEMENT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getManageEnrollementCourses = createAsyncThunk(
  "getManageEnrollementCourses",
  async () => {
    try {
      const response = await CommonService.getAll(GET_MANAGE_ENROLLEMENT_COURSES_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors));
    }
  }
);

export const verifyManageEnrollementPayment = createAsyncThunk(
  "verifyManageEnrollementPayment",
  async (id) => {
    try {
      const response = await CommonService.postData({}, `${VERIFY_MANAGE_ENROLLEMENT_PAYMENT_API_URL}/${id}/verify-payment`);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors));
    }
  }
);

export const manageManageEnrollementSlice = createSlice({
  name: MANAGE_ENROLLEMENT,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.ManageEnrollementErrors = {};
    },
    ManageEnrollementAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.ManageEnrollementButtonSpinner = false;
      }
      state.ManageEnrollementAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageEnrollementEditData    = [];
      state.ManageEnrollementButtonAndModelLabel = setLocale('manageenrollement.add');
    },
    ManageEnrollementEditWithDrawerStatus: (state, action) => {
      state.ManageEnrollementAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageEnrollementEditData = action.payload.data;
      state.ManageEnrollementButtonAndModelLabel = setLocale('manageenrollement.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createManageEnrollement.pending, (state, action) => {
        state.DrawerStatus = 0
        state.ManageEnrollementButtonSpinner = true;
      }).addCase(createManageEnrollement.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.ManageEnrollementButtonSpinner = false;
        state.ManageEnrollementErrors = {}
      }).addCase(createManageEnrollement.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.ManageEnrollementShowMessage = true;
        state.ManageEnrollementButtonSpinner = false;
        state.ManageEnrollementErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getManageEnrollement.pending, (state, action) => {
        state.ManageEnrollementButtonSpinner = true;
        state.ManageEnrollementTableLoading = true;
      }).addCase(getManageEnrollement.fulfilled, (state, action) => {
        state.ManageEnrollementButtonSpinner = false;
        state.ManageEnrollementTableLoading = false;
        state.ManageEnrollementResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getManageEnrollement.rejected, (state, action) => {
        state.ManageEnrollementShowMessage = true; // Set the showMessage flag to display the errors
        state.ManageEnrollementButtonSpinner = false;
        state.ManageEnrollementTableLoading = false;
        state.ManageEnrollementErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewManageEnrollement.pending, (state, action) => {
        state.ViewManageEnrollementLoader = true;
        state.ViewManageEnrollementData = [];
      }).addCase(viewManageEnrollement.fulfilled, (state, action) => {
        state.ViewManageEnrollementLoader = false;
        state.ViewManageEnrollementData = action.payload;
      }).addCase(viewManageEnrollement.rejected, (state, action) => {
        state.ViewManageEnrollementLoader = false;
        state.ViewManageEnrollementData = [];
      })
      .addCase(deleteManageEnrollement.pending, (state, action) => {
        state.ManageEnrollementTableLoading = true;
      }).addCase(deleteManageEnrollement.fulfilled, (state, action) => {
        state.ManageEnrollementTableLoading = false;
      }).addCase(deleteManageEnrollement.rejected, (state, action) => {
        state.ManageEnrollementTableLoading = false;
      })
      .addCase(getManageEnrollementCourses.fulfilled, (state, action) => {
        state.ManageEnrollementCourses = action.payload.data ?? [];
      })
      .addCase(verifyManageEnrollementPayment.pending, (state, action) => {
        state.ManageEnrollementTableLoading = true;
      })
      .addCase(verifyManageEnrollementPayment.fulfilled, (state, action) => {
        state.ManageEnrollementTableLoading = false;
      })
      .addCase(verifyManageEnrollementPayment.rejected, (state, action) => {
        state.ManageEnrollementTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, ManageEnrollementAddDrawerStatus, ManageEnrollementEditWithDrawerStatus, updateSortFilters } = manageManageEnrollementSlice.actions;

export default manageManageEnrollementSlice.reducer;
